export default "__VITE_ASSET__CxpgD9cX__"